import { Route, Routes } from "react-router-dom";
import CocCollectionCreateScreen from "screens/App/CRM/Payment/CocCollection/CocCollectionCreateScreen";
import CocCollectionDetailScreen from "screens/App/CRM/Payment/CocCollection/CocCollectionDetailScreen";
import CocCollectionEditScreen from "screens/App/CRM/Payment/CocCollection/CocCollectionEditScreen";
import CocCollectionListScreen from "screens/App/CRM/Payment/CocCollection/CocCollectionListScreen";
import NotFoundScreen from "screens/NotFoundScreen";

const CocCollectionRouter = () => {
  return (
    <Routes>
      <Route path="create" element={<CocCollectionCreateScreen />} />
      <Route path=":id/detail" element={<CocCollectionDetailScreen />} />
      <Route path="list" element={<CocCollectionListScreen />} />
      <Route path=":id/edit" element={<CocCollectionEditScreen />} />

      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default CocCollectionRouter;
